import ChatMessageEditor from '../Molecules/MessageEditor';

const Chat = ({ event, mainCustomer, eventLocation, customAttributeValues, message }) => {
  const styles = {
    container: {
      // minHeight: "100%",
      display: 'flex',
      flex: '1 1 auto',
      flexDirection: 'column',
      // alignItems: "stretch",
      // height: "74vh",
      minWidth: 0,
      minHeight: 0,
      width: '100%',
    },
    editor: {
      flexShrink: 0,
      position: 'sticky',
      left: 0,
      right: 0,
      bottom: 0,
      height: '100%',
    },
    selectContact: {
      marginBottom: 10,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.editor}>
        <ChatMessageEditor
          email={message}
          event={event}
          mainCustomer={mainCustomer}
          customAttributeValues={customAttributeValues}
          eventLocation={eventLocation}
        />
      </div>
    </div>
  );
};
export default Chat;
